import { z } from "zod";

import { createQueryRequestDefinition } from "~/lib/network/definitions/create";

import {
  renderingAnalysisResponseSchema,
  renderingResultDetailResponseSchema,
  renderingResultsListResponseSchema,
} from "./schemas";

export const fetchJerboaRenderingResultsQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "jerboa", "rendering-results", "list"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/jerboa-rendering-results",
  paramsSchema: z.object({
    afterCursor: z.string().nullable().optional().default(null),
    pageSize: z.number().max(50).optional().default(50),
    status: z.enum(["SUCCESS", "RENDER_FAILED"]).optional(),
    projectType: z.enum(["captions-only", "ai-edit"]).optional(),
  }),
  responseSchema: renderingResultsListResponseSchema,
}).withPagination({
  getNextPageParam(lastPage) {
    return lastPage.results.pageInfo.hasNextPage ? lastPage.results.pageInfo.endCursor : undefined;
  },
  mapPaginationParamsToQueryParams({ pageParam }) {
    return {
      ...(pageParam ? { afterCursor: pageParam } : {}),
      pageSize: 50,
    };
  },
});

export const getJerboaRenderingResultQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "jerboa", "rendering-results", "detail"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/jerboa-rendering-results/:resultId",
  responseSchema: renderingResultDetailResponseSchema,
});

export const fetchJerboaRenderingAnalysisQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "jerboa", "rendering-analysis"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/jerboa-rendering/analysis",
  paramsSchema: z.object({
    days: z.number().min(1).max(90).default(7),
  }),
  responseSchema: renderingAnalysisResponseSchema,
});
